module.exports = __webpack_public_path__ + "static/media/Red_Timer@3x.d25f20cd.png";